import React, { useCallback } from 'react';
import { IStepSwitch } from '../interfaces';
import { STEPS } from '../consts';
import { IntroPreLoad } from './IntroPreLoad';
import { Intro } from './Intro';
import { Amount } from './Amount';
import { Review } from './Review';
import { Success } from './Success';
import { LimitReached } from './LimitReached';

export const StepSwitch = ({ activeStep, shouldShowSkeleton }: IStepSwitch) => {
  const getActiveStep = useCallback(() => {
    switch (activeStep) {
      case STEPS.LOADER:
        return <IntroPreLoad shouldShowSkeleton={shouldShowSkeleton} />;
      case STEPS.INTRO:
        return <Intro />;
      case STEPS.AMOUNT:
        return <Amount />;
      case STEPS.REVIEW:
        return <Review />;
      case STEPS.SUCCESS:
        return <Success />;
      case STEPS.NON_ELIGIBLE:
        return <LimitReached />;
      default:
        return <Intro />;
    }
  }, [activeStep]);
  return (
    <>
      {getActiveStep()}
    </>
  );
};
